// src/components/Skills.js
import React from "react";
import { useSite } from "../context/SiteContext";
import "./Skills.css";

const Skills = () => {
  const { skills, loading } = useSite();

  return (
    <section className="skills-section">
      <div className="container">
        <p className="section-label">Expertise</p>
        <h2 className="section-title" style={{ marginBottom: "3rem" }}>My Skills</h2>

        <div className="skills-grid">
          {loading
            ? Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="skills-card card">
                  <div className="skills-card__header">
                    <div className="skeleton" style={{ width: 32, height: 32, borderRadius: 8 }} />
                    <div className="skeleton" style={{ width: "60%", height: 18 }} />
                  </div>
                  {Array.from({ length: 4 }).map((_, j) => (
                    <div key={j} className="skeleton" style={{ height: 14, marginBottom: 8, width: `${65 + j * 8}%` }} />
                  ))}
                </div>
              ))
            : skills.map(({ category, icon, items }) => (
                <div key={category} className="skills-card card">
                  <div className="skills-card__header">
                    <span className="skills-card__icon">{icon}</span>
                    <h3 className="skills-card__title">{category}</h3>
                  </div>
                  <ul className="skills-card__list">
                    {items.map((skill) => (
                      <li key={skill} className="skills-card__item">
                        <span className="skills-card__dot" />
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
